import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/boom.png";

import {
  AiFillGithub,
 
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">


            I consider myself as a  <b className="purple">developer</b>  in the evolving tech field.
            With a strong passion for technology and a good understanding of <b className="purple">software development</b>. 
            <br>
            </br>
            I thrive on creating  <b className="purple">innovative solutions</b>  that address real-world challenges. 
            <br>
            </br>
            As a developer, I have honed my skills in various <b className="purple"> programming languages </b>, <b className="purple">frameworks</b>, and  <b className="purple">technologies </b> .
            <br>
            </br>
            <br>
            </br>
            I possess proficiency in <b className="purple"> C++ and Python. </b> and a  <b className="purple"> few Web Technologies</b> . 
            <br></br>
            
            My areas of interest revolve around    <b className="purple"> building new Products</b> and working with  various  <b className="purple"> Web Technologies</b> .
            <br></br>
            I also possess good  <b className="purple">   problem-solving </b> and  <b className="purple">    analytical abilities </b> and I enjoy diving into complex problems, breaking them down into manageable components, and finding elegant solutions.
            <br>
            </br>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
          
              <img src={myImg} className="img-fluid" alt="avatar" />

          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>JOIN ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/avdhesh201"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
             
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/avdhesh-kumar-singh-939146204/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
